var React = require('react');

function Avatar (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("g",{"stroke":"currentColor","key":0},[React.createElement("circle",{"cx":"16.5","cy":"13.5","r":"4.5","strokeWidth":"2","key":0}),React.createElement("path",{"strokeWidth":"2","d":"M25.302 26.92A9.503 9.503 0 0 0 16.5 21a9.503 9.503 0 0 0-8.8 5.913","key":1})]),React.createElement("circle",{"cx":"16.5","cy":"16.5","r":"13.5","stroke":"#57E8FC","strokeWidth":"3","key":1})]));
}

Avatar.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Avatar;

Avatar.default = Avatar;
